export const AlertModel = {
  nome: "",
  email: "",
  telefone: "",
  codIso: "",
  valor: 0,
  dataLimite: "",
};
